import { LazyToastContainer } from "@faire/deprecated-retailer-visitor-shared/components/Toast";
import { getSpacing } from "@faire/web/slate/spacing";
import { cn } from "@faire/web/tools/cn";
import { useViewport } from "@faire/web/ui/hooks/useViewport";
import React, { Suspense } from "react";

import { toastTopVar } from "./consts.css";

type Props = {
  style: React.CSSProperties | undefined;
};

export const ToastContainer: React.FC<Props> = ({ style }) => {
  const { isMobile } = useViewport();

  return (
    <div
      className={cn("sticky top-0 z-12 h-0", toastTopVar.className)}
      style={style}
    >
      <Suspense fallback={null}>
        <LazyToastContainer
          position={isMobile ? "bottom-center" : "top-right"}
          style={isMobile ? undefined : DESKTOP_AND_ABOVE_STYLE}
        />
      </Suspense>
    </div>
  );
};

const DESKTOP_AND_ABOVE_STYLE: React.CSSProperties = {
  position: "absolute",
  top: "initial",
  bottom: getSpacing("-3x"),
  right: getSpacing("3x"),
  left: "auto",
  width: "fit-content",
  height: "fit-content",
  padding: "0",
  zIndex: 11,
  maxWidth: "325px",
  transform: "translateY(100%)",
};
